import { orderedCategories } from '@milk/shared';
import { useStore } from '../store/store';
import { Dialog } from './ui';

/** Pick a section, listed in the store's walking order. */
export function SectionPicker({ title, current, storeId, onPick, onClose, note }: {
  title: string; current: string | null; storeId: string | null; onPick(id: string): void; onClose(): void; note?: string;
}) {
  const categories = useStore((s) => s.categories);
  const store = useStore((s) => (storeId ? s.stores[storeId] : null));
  const list = orderedCategories(store, Object.values(categories));
  return (
    <Dialog title={title} onClose={onClose}>
      {note && <p className="muted small" style={{ marginTop: 0 }}>{note}</p>}
      <ul className="choices" aria-label="Sections">
        {list.map((c) => (
          <li key={c.id}>
            <button type="button" className="choice" aria-pressed={c.id === current} onClick={() => onPick(c.id)}>
              <span aria-hidden>{c.emoji}</span> {c.name}
            </button>
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
